/*** IMPORTS FROM imports-loader ***/
(function() {

require([
    'jquery',
    'pip-events',
    'pip-model',
    'pip-common.tooltips',
    'pip-analytics',
    'pip-breadcrumbs',
    'pip-common.validate',
    'item_related_groups',
    'pip-sticky-nav',
    'pip-quantity',
    'pip-home-services-coordinator-legacy',
    'pip-home-services-coordinator',
    'pip-product-add-ons',
    'pip-messaging-in_store_assembly',
    'pip-price',
    'pip-ecorebates',
    'pip-ssku',
    'pip-buybelt',
    'pip-recommendations',
    'pip-specifications',
    'pip-analytics__hddata',
    'frequently_bought_together',
    'pip-prop65-warning',
    'pip-rich-content',
    'pip-navigation',
    'pip-ratings-reviews',
    'pip-ratings-reviews-react',
    'pip-media-manager',
    'pip-media-gallery',
    'pip-media-expanded-view',
    'pip-sharebelt',
    'pip-myList',
    'pip-feature_based_recommendations',
    'thd-carousel',
    'pip-related_search_and_products',
    'cookie-utils',
    'commission-junction',
    'breakpoints',
    'pip-shipping_service_levels',
    'pip-cards',
    'pip-domain',
    'auth.service',
    'verification.service',
    'pip-module-positioner',
    'pip-subscribe_and_save',
    'pip-calculator',
    'pip-installation_options',
    'pip-installation_guide',
    'pip-default-badging',
    'consumer-credit-message',
    'order-sample',
    'moving-calculator',
    'measurement-guide',
    'pip-expose-tnt-objects',
    'pip-analytics__consumer-credit-message',
    'pip-new-relic',
    'custom-product-offering',
    'repeat-purchase-banner',
    'augmented-reality',
    'pip-multi-sku',
    'disclaimer-message',
    'pip-buy_one_get_one'
],
function (
    $,
    pipEvents,
    pip,
    pipTooltips,
    pipAnalytics,
    pipBreadcrumbs,
    pipValidate,
    pipIRG,
    pipStickyNav,
    pipQuantity,
    pipHomeServicesCoordinatorLegacy,
    pipHomeServicesCoordinator,
    pipProductAddOns,
    pipMessagingInStoreAssembly,
    pipPrice,
    pipEcorebates,
    pipSSKU,
    pipBuyBelt,
    pipRecommendations,
    pipSpecifications,
    analyticsHDdata,
    frequentlyBoughtTogether,
    pipProp65Warning,
    pipRichContent,
    pipNavigation,
    pipRatingsReviews,
    pipRatingsReviewsReact,
    pipMediaManager,
    pipMediaGallery,
    pipMediaExpandedView,
    pipSharebelt,
    pipMyList,
    pipFeatureBasedRecommendations,
    thdCarousel,
    pipRelatedSearchAndProducts,
    cookieUtils,
    commissionJunction,
    breakpoints,
    pipShippingServiceLevels,
    pipCards,
    pipDomain,
    myAccountService,
    myVerificationService,
    pipModulePositioner,
    pipSubscribeAndSave,
    pipCalculator,
    pipInstallationOptions,
    pipInstallationGuide,
    pipDefaultBadging,
    consumerCreditMessage,
    orderSample,
    movingCalculator,
    measurementGuide,
    pipExposeTntObjects,
    analyticsConsumerCreditMessage,
    pipNewRelic,
    customProductOffering,
    repeatPurchaseBanner,
    augmentedReality,
    pipMultiSku,
    disclaimerMessage,
    pipBuyOneGetOne
){

    if (typeof DIGITAL_EMITTER !== 'undefined') {
        DIGITAL_EMITTER.trigger('jquery-ready');
    }

    var currentBreakpoint = breakpoints.getCurrentBreakpoint();

    // GLOBAL
    if(window.thdOnlineCommon){
        window.thdOnlineCommon.appAlias = "S6";
    }

    pipEvents.media.mediaLoaded.on('.mediaLoaded', function () {
        pipMediaGallery.init();
    });

    pipEvents.media.expandMediaView.on('.expandMediaView', function (evtType, data) {
        pipMediaExpandedView.build(data.target);
    });

    pipEvents.bazaarVoice.bazaarVoiceRatingsReviewLoaded.on('.bazaarVoiceRatingsReviewLoaded', function () {
        pipStickyNav.updateRatingsReviews();
    });

    pipEvents.ssku.sskuChange.off('.sskuChange');
    pipEvents.ssku.sskuChange.on('.sskuChange', function(evtType, data) {
        initPip(data);
        pipNavigation.updateUrl();
        pipNavigation.updatePageTitle();
        THD && THD.DataCollection && THD.DataCollection.recordPageLoad();
        pipEvents.ssku.sskuInteraction.trigger(data);
    });

    //TODO: add this to all sdsku experiences
    pipEvents.ssku.sdskuChange.off('.sdskuChange');
    pipEvents.ssku.sdskuChange.on('.sdskuChange', function(evtType, data) {
        pip.update(data);
        pipSSKU.init(data.sdskuSelectedAttributes);
    });


    $(function() {
        pipExposeTntObjects.init();
        cookieUtils.initializeCookieManager(pipDomain.getCookieDomain(), 'web');
        commissionJunction.updateCJInfo();
        myAccountService.init();
        myVerificationService.init();

        window.pipModelRequest.then(function(data) {
            initPip(data);
            pipValidate.init();
            pipAnalytics.init();
            pipBreadcrumbs.init();
            if (!pip.isB2BCustomer) {
                analyticsConsumerCreditMessage.init();
              }


            // PLEASE: don't put anything after this event
            var afterBundleEvent = document.createEvent('CustomEvent');
            afterBundleEvent.initCustomEvent('afterBundle', false, false, {});
            document.dispatchEvent(afterBundleEvent);
        });
    });

    function initPip(data){
        if(data.featureState && data.featureState.pipCustomNewRelic){
            pipNewRelic.init();
        }

        pipBuyBelt.removeLoadingErrorState();
        pip.update(data);
        pipBuyBelt.init();
        pipRecommendations.init();
        pipModulePositioner.init();
        pipStickyNav.init();
        pipMediaManager.update();
        thdCarousel.init();
        pipRelatedSearchAndProducts.init();
        analyticsHDdata.init();

        if (pip.features.buyOneGetOneFreeEnabled) {
          pipBuyOneGetOne.init();
        }
        if (pip.features.servicesLifeCycleEventFixEnabled){
            pipEvents.pipLifecycleEvents.attachLabor.attachLaborProcessed.off();
        }
        if (pip.features.refactorHomeServicesCoordinatorEnabled) {
            pipHomeServicesCoordinator.init();
        } else {
            pipHomeServicesCoordinatorLegacy.init();
        }

        pipIRG.init();

        // TODO: Leaving like this for a time to allow for discussion.  For the record, thinking it makes sense to
        // always call pipProductAddOns.init() and pipInstallationOptions.init() and push attachLaborProcessed.on()
        // calls into those methods.
        pipEvents.pipLifecycleEvents.attachLabor.attachLaborProcessed.on(function attachLaborProcessed(homeServicesAddOnAvailability) {
            pipProductAddOns.init();
            if (homeServicesAddOnAvailability.isAvailable && !pip.isB2BCustomer) {
                pipInstallationOptions.init();
            }
        });

        pipQuantity.init();
        pipMessagingInStoreAssembly.init();
        pipPrice.init();
        pipMultiSku.init();
        pipEcorebates.init();
        pipSSKU.init();
        pipShippingServiceLevels.init();
        pipSpecifications.init();
        frequentlyBoughtTogether.init();
        pipProp65Warning.init();
        pipRichContent.init();
        pipNavigation.init();
        pipRatingsReviewsReact.init();
        pipRatingsReviews.init();
        pipSharebelt.init();
        pipFeatureBasedRecommendations.init();
        pipCards.init();
        pipMyList.init();
        pipSubscribeAndSave.init();
        pipCalculator.init();
        repeatPurchaseBanner.init();
        if (!pip.isB2BCustomer) {
          consumerCreditMessage.init();
          pipInstallationGuide.init();
        }
        orderSample.init();
        movingCalculator.init();
        measurementGuide.init();
        pipDefaultBadging.init();
        disclaimerMessage.init();
        //--non-responsive
        //breakpoints.init();
        augmentedReality.init();

      if(pip.features.customProductOfferingEnabled && pip.isB2BCustomer &&
        (pip.features.customProductOfferingEnabledInExperience.indexOf('ALL') !== -1 || pip.features.customProductOfferingEnabledInExperience.indexOf('DEFAULT') !== -1 )) {
        customProductOffering.init();
      }
    }
});

}.call(window));